import { render } from "./ParcelaBoleto.vue?vue&type=template&id=d36ed25e"
import script from "./ParcelaBoleto.vue?vue&type=script&lang=js"
export * from "./ParcelaBoleto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__